import { render } from "./ChatRoom.vue?vue&type=template&id=64042ad0&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"

import "./ChatRoom.vue?vue&type=style&index=0&id=64042ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64042ad0"]])

export default __exports__